import { useCallback, useMemo } from "react";

export type SellerDraft = {
  sellerName: string;
  sellerWhatsapp: string;
  sellerEmail: string;
};

const STORAGE_KEY = "fidexa.alpha7.seller";

const EMPTY: SellerDraft = { sellerName: "", sellerWhatsapp: "", sellerEmail: "" };

const read = (): SellerDraft => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return EMPTY;
    const parsed = JSON.parse(raw) as Partial<SellerDraft>;
    return {
      sellerName: typeof parsed.sellerName === "string" ? parsed.sellerName : "",
      sellerWhatsapp:
        typeof parsed.sellerWhatsapp === "string" ? parsed.sellerWhatsapp : "",
      sellerEmail: typeof parsed.sellerEmail === "string" ? parsed.sellerEmail : "",
    };
  } catch {
    return EMPTY;
  }
};

/**
 * Guarda os dados do vendedor no navegador para ele não redigitar nome,
 * WhatsApp e e-mail a cada farmácia indicada. É conveniência por dispositivo:
 * fica só neste navegador e some ao "Limpar formulário". Tudo em try/catch
 * porque em aba anônima ou com armazenamento bloqueado o localStorage lança.
 */
export const useSellerDraft = () => {
  const initial = useMemo(read, []);

  const save = useCallback((draft: SellerDraft) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(draft));
    } catch {
      // Sem armazenamento, o vendedor só redigita na próxima vez.
    }
  }, []);

  const clear = useCallback(() => {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch {
      // Idem.
    }
  }, []);

  return { initial, save, clear };
};
